import React from 'react';import style from './index.scss';
import GamesView from '../../common/GamesView';

export const GamesCategory = ({ games, trackChangeGameClick, isInMissionsItemCard, updateCardHeight, imageMission,
                                  urlMission, missionStatus }) => {
    return <div className={style.block}>
        <GamesView
            gameCodes={games}
            isShowPlayButtonOnHover={true}
            trackChangeGameClick={trackChangeGameClick}
            isInMissionsItemCard={isInMissionsItemCard}
            updateCardHeight={updateCardHeight}
            imageMission={imageMission}
            urlMission={urlMission}
            missionStatus={missionStatus}
        />
    </div>;
};

export const GamesForMobile = ({ games, activeTab, tabClick, id, className = '', isInMissionsItemCard,
                                   updateCardHeight, imageMission, urlMission, missionStatus, ...rest }) => (
    <div className={`${className} ${style.container}`}>
        <GamesCategory key={id} {...{ id, isInMissionsItemCard, updateCardHeight, imageMission, urlMission,
            missionStatus, games, ...rest }} />
    </div>
);

export default GamesForMobile;
